import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { RoleRequestCartComponent } from '../role-request-cart/role-request-cart.component';
import { Router, RouterModule } from '@angular/router';
import { Observable, Subject, debounceTime, distinctUntilChanged, switchMap, takeUntil, tap } from 'rxjs';
import { RoleRequestService } from 'src/app/modules/user-profile/services/role-request.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { AlertComponent } from 'src/app/modules/shared/components/alert/alert.component';
import { MultiOrgFilterTAComponent } from '../multi-org-filter-ta/multi-org-filter-ta.component';
import { RoleRequestSuccessComponent } from '../role-request-success/role-request-success.component';
import { SpinnerComponent } from 'src/app/modules/shared/components/spinner/spinner.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserRole } from 'src/app/modules/user-profile/models/user-role';

@Component({
  selector: 'app-role-request-remove-employee-role',
  imports: [CommonModule, MultiOrgFilterTAComponent, RoleRequestCartComponent, NgSelectModule, SpinnerComponent, FormsModule, AlertComponent, RoleRequestSuccessComponent, RouterModule, RoleRequestCartComponent],
  templateUrl: './role-request-remove-employee-role.component.html',
  styleUrl: './role-request-remove-employee-role.component.css'
})
export class RoleRequestRemoveEmployeeRoleComponent implements OnInit, OnDestroy {
  private roleRequestService = inject(RoleRequestService);
  private router = inject(Router);
  private spinner = inject(NgxSpinnerService);

  profileAdminCheckbox = 2123430000;
  rolesOnCart = [];
  selectedRoles = [];
  userRoles: any[] = [];
  employees$: Observable<any[]>;
  search$ = new Subject<string>();
  loading = false;
  selectedEmployee;
  showErrorMessage: string;
  today = new Date().toISOString().split('T')[0];
  isRequestSuccess = false;
  isDewStaff = false;
  hasProfileAdmin = false;
  isDewOrg = false;
  unsubscribe$ = new Subject();
  initialSelRole: UserRole = null;

  constructor() {
    this.employees$ = this.search$.pipe(debounceTime(300), distinctUntilChanged(), switchMap(term => this.search(term)))
  }


  ngOnInit(): void {
    this.roleRequestService.hasAuthorizationForComponent(this.profileAdminCheckbox).subscribe((res: boolean) => {
      this.hasProfileAdmin = res;
    });
    this.roleRequestService.multiOrgFilters$.pipe(takeUntil(this.unsubscribe$)).subscribe((res: any) => {
      this.isDewOrg = res?.selectedRoleGroup?.roleAssignGroupKey == '1';
      this.isDewStaff = false;
    });
  }

  onEmployeeSelect(event) {
    if (!event) {
      return;
    }
    this.spinner.show('remove-emp-role');
    this.roleRequestService.getRolesByPersonKey(event.key, true).subscribe(data => {
      this.loading = false;
      this.userRoles = data.personOrgRole.personOrgRoleList.filter(x => x.organization.key === this.roleRequestService.multiOrgFilters.selectedOrganization?.orgKey)
      this.userRoles.forEach(role => {
        const roleResponsibility = data.roleResponsibilities.find(x => x.roleKey === role.role.key);
        if (roleResponsibility) {
          role.roleResponsibilities = roleResponsibility.roleResponsibilities;
          role.roleResponsibilities?.forEach((x: any) => {
            x.roleResponsibility = x.roleResponsibility.split('.').filter(x => x).map(x => x + '.');
            x.roleResponsibility = [...new Set(x.roleResponsibility)];
            if( x.roleResponsibility.length > 1) {
              x.roleResponsibility = x.roleResponsibility.filter(x => !x.includes('No Information available'));
            }
          })
        }
      });
      this.userRoles.sort((a, b) => a.role?.name?.localeCompare(b?.role?.name));
      this.spinner.hide('remove-emp-role');
    }, err => {
      this.spinner.hide('remove-emp-role');
      this.showError(err.error.resultMessage);
    });
  }

  isSelected(roleSel: any) {
    return this.selectedRoles.find(role => roleSel.role.key == role.role.key);
  }

  onRoleCheckBoxChage(event: any, roleSelected: any) {
    if (event.target.checked) {
      if(!this.initialSelRole  || !this.initialSelRole?.['reason']) {
        this.initialSelRole = roleSelected;
      } else if(!roleSelected.reason) {
        roleSelected.reason = this.initialSelRole?.['reason'];
      }
      this.selectedRoles.push(roleSelected);
    } else {
      this.selectedRoles = this.selectedRoles.filter(role => role.roleKey !== roleSelected.key);
    }
  }

  addRolesToCart() {
    this.showErrorMessage = '';
    if(this.selectedRoles.some(role => !role.reason?.trim())) {
      this.showError("Please provide a reason to remove for all selected roles.");
      return;
    }

    this.selectedRoles.forEach(role => {
      if (!this.rolesOnCart.find(x => x.role.key === role.role.key)) {
        this.rolesOnCart.push({ ...role, applicationRoleName: role.role.name });
        this.userRoles = this.userRoles.filter(urole => urole.role.key !== role.role.key);
      }
    });
  }


  removeRole(role) {
    this.rolesOnCart = this.rolesOnCart.filter(x => x.role.key !== role.role.key);
    this.selectedRoles = this.selectedRoles.filter(x => x.role.key !== role.role.key);
    this.userRoles.push({ ...role });
    this.userRoles.sort((a, b) => a.roleName?.localeCompare(b.roleName));
  }

  submitRoleRequest() {
    let payload = [];
    const multiFilters = this.roleRequestService.multiOrgFilters;
    this.loading = true;
    this.spinner.show('remove-emp-role');
    this.rolesOnCart.forEach(role => {
      payload.push({
        personKey: +this.selectedEmployee.key,
        roleKey: role.role.key,
        usageTypeKey: 0,
        assignGroupKey: +multiFilters.selectedRoleGroup.roleAssignGroupKey,
        orgKey: multiFilters.selectedOrganization?.orgKey,
        roleRequestText: role.reason || ' ',
        roleRequestTypeKey: 2,
        effectiveDate: this.today
      })
    })
    this.roleRequestService.roleRequestPost(payload, this.hasProfileAdmin).subscribe(data => {
      this.loading = false;
      this.showErrorMessage = '';
      this.isRequestSuccess = true;
      this.spinner.hide('remove-emp-role');
    },
      err => {
        this.loading = false;
        this.spinner.hide('remove-emp-role');
        this.showError(err?.error?.resultMessage || 'Error submitting role request');
      }
    )
  }

  search(selectedEmployee) {
    this.loading = true;
     return this.roleRequestService.searchEmployee(selectedEmployee, this.isDewStaff, this.isDewOrg)
        .pipe(takeUntil(this.unsubscribe$), tap(() => this.loading = false));
  }

  onClear() {
    this.selectedEmployee = null;
    this.userRoles = [];
    this.selectedRoles = [];
    this.loading = false;
  }

  showError(message: string): void {
    this.showErrorMessage = message;
    window.scrollTo(0, 0);
  }

  ngOnDestroy() {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }

  onDewStaffChange(event) {
    this.selectedEmployee = null;
    this.userRoles = [];
    this.selectedRoles = [];
  }

}
